<script lang="ts">
  import Link from "svelte-link";
  import { Card, Col, Image } from "sveltestrap";
  import {learningBlogData} from "../../../Data/Miscellaneous/LearningList"
  import { bottomdetail } from "../../../utils/Constant/Constant";
  let imgPath:string = "/assets/images/faq"
</script>
{#each learningBlogData as blogItem}
    <Col xl="4" sm="6"  class="xl-50 box-col-6">
        <Card>
            <div class="product-box learning-box">
                <div class="product-img">
                    <Image fluid class="top-radius-blog" src="{imgPath}/{blogItem.img}" />
                    <div class="product-hover">
                        <ul>
                            {#each blogItem.icon as iconItem}
                                <li>
                                    <Link href="/learning/detailedcourse">
                                        <i class={iconItem}></i>
                                    </Link>
                                </li>
                            {/each}
                        </ul>
                    </div>
                </div>
                <div class="details-main">
                    <Link href="/learning/detailedcourse">         
                        <div class="bottom-details"> 
                            <h6>{blogItem.title}</h6>
                        </div>
                    </Link>
                    <p>{bottomdetail}</p>
                </div>
            </div>
        </Card>
    </Col>
{/each}